import React, { useState } from "react";
import { Grid, Stack, Typography, Button } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { countries } from "country-data";
import StarIcon from "@mui/icons-material/Star";
import { useNavigate } from "react-router-dom";

const FindExpertCard = ({
  bid,
  clickHandler,
  name,
  country,
  skills,
  id,
  rating,
}) => {
  const navigate = useNavigate();
  const getQuoteHandler = () => {
    navigate(`/expert-profile/${id}`);
  };
  return (
    <Grid
      container
      style={{
        borderBottom: "1px solid #EEEBEF",
        marginTop: "20px",
        paddingBottom: "20px",
        cursor: "pointer",
      }}
      // alignItems="center"
      //   onClick={() => clickHandler(bid._id)}
    >
      {/* <Grid item sm={1}></Grid> */}
      <Grid item sm={2}>
        <AccountCircleIcon
          style={{
            height: "80px",
            width: "80px",
            color: "#EEEBEF",
            marginLeft: "20px",
          }}
        />
      </Grid>
      <Grid item sm={9}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            className="mb-5"
          >
            <Typography
              style={{ fontWeight: "bold", textTransform: "capitalize" }}
            >
              {name}
            </Typography>
            <CheckCircleIcon
              style={{ height: "15px", width: "15px", color: "#FA8319" }}
            />
          </Stack>
          <Button
            variant="contained"
            className="primary-button"
            style={{ textTransform: "capitalize" }}
            onClick={getQuoteHandler}
          >
            Get Quote
          </Button>
        </Stack>

        <Typography
          className="mb-5"
          style={{ color: "rgba(122, 122, 128, 1)" }}
        >
          {countries[country].name}
        </Typography>
        <Stack
          style={{
            padding: "3px",
            borderRadius: "4px",
            backgroundColor: "rgba(52, 168, 83, 0.3)",
            width: "10%",
          }}
          spacing={1}
          direction="row"
          alignItems="center"
          className="mb-5"
        >
          <StarIcon
            style={{
              height: "18px",
              width: "18px",
              color: "rgba(52, 168, 83, 1)",
            }}
          />
          <Typography style={{ color: "rgba(52, 168, 83, 1)" }}>
            {rating}
          </Typography>
        </Stack>
        <Grid container className="mt-10" columnSpacing={2} rowSpacing={2}>
          {skills.map((skill) => (
            <Grid item sm={4}>
              <Typography
                className="ammanat-darker-gray skill-pill"
                style={{ fontSize: "13px" }}
              >
                {skill.label}
              </Typography>
            </Grid>
          ))}
        </Grid>
        {/* <Stack direction="row" spacing={2} className="mt-10">
          {skills.map((skill) => (
            <Typography className="ammanat-darker-gray skill-pill">
              {skill.label}
            </Typography>
          ))}
        </Stack> */}
      </Grid>
    </Grid>
  );
};

export default FindExpertCard;
